/**
 * sidebarSocialMedia.js
 * UA_Social_Media_Widget
 */

// Import
import "./sidebarSocialMedia.scss";
import $ from 'jquery';

$(document).ready(function() {

});